<div class="view-menu-scrim" *ngIf="menuOpen$ | async" (click)="handleCloseClick()"></div>

<app-view-column placement="right" @slideInOut *ngIf="menuOpen$ | async" class="view-menu-column">
    <nav app-view-list-container>
        <app-view-panel padding="dense" [showHeader]="false">
            <app-view-logo></app-view-logo>
        </app-view-panel>

        <app-view-panel padding="dense" [showHeader]="false">
            <button app-view-list-item (click)="handleCloseClick()">
                Close
            </button>
        </app-view-panel>

        <!-- Openers -->
        <app-view-panel padding="dense" [showHeader]="false">
            <button app-view-list-item (click)="handleToggleToolbar('tools')">
                <app-icon icon="pen" class="mr-3"></app-icon>
                Open Explore Tools
            </button>

            <button app-view-list-item (click)="handleToggleToolbar('media')">
                <app-icon icon="play" class="mr-3"></app-icon>
                Open Media Controls
            </button>

            <button app-view-list-item (click)="handleSearchClick()">
                <app-icon icon="search" class="mr-3"></app-icon>
                Search Anatomy
            </button>
        </app-view-panel>

        <!-- Presentation Modes -->
        <app-view-panel padding="dense" [showHeader]="false">
            <button app-view-list-item (click)="handleFullscreenClick()">
                <app-icon icon="expand" class="mr-3"></app-icon>
                Enter Fullscreen
            </button>
        </app-view-panel>

        <!-- Toggles -->
        <app-view-panel padding="dense" [showHeader]="false">
            <button app-view-list-item (click)="handleToggleLabelsClick()">
                <app-icon icon="tag" class="mr-3"></app-icon>
                <span class="mr-3">Toggle Labels</span>
                <span *ngIf="showLabels$ | async" class="text-dim">(On)</span>
                <span *ngIf="!(showLabels$ | async)" class="text-dim">(Off)</span>
            </button>
        </app-view-panel>

        <!-- Help -->
        <app-view-panel padding="dense" [showHeader]="false">
            <button 
                app-view-list-item
                (click)="handleTutorialClick()"
                [disabled]="!(selectedChapterReady$ | async)?.model">
                Launch Tutorial
            </button>
            <button app-view-list-item (click)="handleHelpBasicsClick()">3D Navigation Basics</button>
            <button app-view-list-item (click)="handleHelpShortcutsClick()">Keyboard Shortcuts</button>
        </app-view-panel>
    </nav>
</app-view-column>